import moment from "moment-timezone";

let started = !process.browser;

const timezoneHelper = (ctx, next) => {
  const { req, res, locals } = ctx;
  const currentTimeZone = moment.tz.guess();
  let savedTimeZone = req.cookies.currentTimeZone;

  // Handle initial utc offset save or update in vorwser.
  if (!savedTimeZone || (process.browser && started)) {
    savedTimeZone = currentTimeZone;
    res.cookie("currentTimeZone", currentTimeZone);
  }

  // Setup locale aware moment.
  ctx.momentTZ = locals.momentTZ = (...args) =>
    moment(...args).tz(savedTimeZone);
  ctx.momentTZUTC = locals.momentTZUTC = (...args) =>
    moment.utc(...args).tz(savedTimeZone);

  started = true;
  return next();
};

export default timezoneHelper;
